import React from 'react';
import { Box, Typography, Button, IconButton, useTheme } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import CodeIcon from '@mui/icons-material/Code';

const ProjectCard = ({ project }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        // --- Card Dimensions & Positioning ---
        position: 'relative',
        flexShrink: 0, // Prevents cards from shrinking in the flex container
        width: '300px',
        height: '400px',
        borderRadius: 2,
        overflow: 'hidden', // Hides overflowing content and the image zoom effect
        boxShadow: 3,
        transition: 'all 0.4s ease-in-out',

        // --- Hover State for the whole card ---
        '&:hover': {
          boxShadow: 8,
          transform: 'translateY(-8px)',
        },
        // --- Animate the image on hover ---
        '&:hover .project-image': {
          transform: 'scale(1.1)',
        },
        // --- Show the details overlay on hover ---
        '&:hover .project-details': {
          transform: 'translateY(0)',
          opacity: 1,
        },
      }}
    >
      {/* Background Image */}
      <Box
        className="project-image"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${project.imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          transition: 'transform 0.5s ease-in-out',
        }}
      />

      {/* Content Overlay */}
      <Box
        className="project-details"
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: 3,
          textAlign: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Semi-transparent overlay
          color: '#fff',

          // --- Animation Properties ---
          opacity: 0,
          transform: 'translateY(100%)', // Start hidden at the bottom
          transition: 'all 0.4s ease-in-out',
        }}
      >
        <Typography variant="h5" component="h3" fontWeight="bold" gutterBottom>
          {project.title}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {project.description}
        </Typography>

        {/* Action Buttons */}
        <Box>
          {/* <Button
            variant="contained"
            startIcon={<LinkIcon />}
            href={project.liveUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ mr: 1 }}
          >
            Live Demo
          </Button> */}
          {/* <IconButton
            href={project.sourceUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#fff' }}
          >
            <CodeIcon />
          </IconButton> */}
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectCard;